import type { LocaleMorpheus } from "@solvari/translations";

import { localeToIso } from "@solvari/translations";
import {
  getEnv,
  handleNetwork,
  kyNoCredentials,
  memoize,
} from "@solvari/utils";

type CompanyDetail = {
  city: string;
  companyId: number;
  companyName: string;
  houseNr: string;
  id: number;
  street: string;
  zipCode: string;
};

const searchCompanies = memoize(
  handleNetwork(
    async ({
      companyName,
      locale,
    }: {
      companyName: string;
      locale: LocaleMorpheus;
    }) => {
      const { results } = await kyNoCredentials
        .post(`${getEnv().network.api}/system/v2/credit-device/search`, {
          json: { term: companyName, locale: localeToIso(locale) },
        })
        .json<{ results: CompanyDetail[] }>();

      return results;
    },
  ),
);

export { type CompanyDetail, searchCompanies };
